declare namespace $ {

	type $shm_hitalama_components_drafts_list__model_shm_hitalama_components_drafts_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts['model'] >
		,
		ReturnType< $shm_hitalama_components_drafts_list['model'] >
	>
	type $shm_hitalama_components_drafts_list__selected_shm_hitalama_components_drafts_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts['selected'] >
		,
		ReturnType< $shm_hitalama_components_drafts_list['selected'] >
	>
	type $shm_hitalama_components_drafts_list__created_shm_hitalama_components_drafts_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts['created'] >
		,
		ReturnType< $shm_hitalama_components_drafts_list['created'] >
	>
	type $shm_hitalama_components_drafts_list__opened_shm_hitalama_components_drafts_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts['opened'] >
		,
		ReturnType< $shm_hitalama_components_drafts_list['opened'] >
	>
	type $shm_hitalama_components_drafts_preview__model_shm_hitalama_components_drafts_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts['model'] >
		,
		ReturnType< $shm_hitalama_components_drafts_preview['model'] >
	>
	type $shm_hitalama_components_drafts_preview__selected_shm_hitalama_components_drafts_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts['selected'] >
		,
		ReturnType< $shm_hitalama_components_drafts_preview['selected'] >
	>
	type $shm_hitalama_components_drafts_preview__editing_shm_hitalama_components_drafts_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts['editing'] >
		,
		ReturnType< $shm_hitalama_components_drafts_preview['editing'] >
	>
	type $shm_hitalama_components_drafts_preview__close_shm_hitalama_components_drafts_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts['close'] >
		,
		ReturnType< $shm_hitalama_components_drafts_preview['close'] >
	>
	type $shm_hitalama_components_drafts_editor__model_shm_hitalama_components_drafts_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts['model'] >
		,
		ReturnType< $shm_hitalama_components_drafts_editor['model'] >
	>
	type $shm_hitalama_components_drafts_editor__selected_shm_hitalama_components_drafts_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts['selected'] >
		,
		ReturnType< $shm_hitalama_components_drafts_editor['selected'] >
	>
	type $shm_hitalama_components_drafts_editor__editing_shm_hitalama_components_drafts_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts['editing'] >
		,
		ReturnType< $shm_hitalama_components_drafts_editor['editing'] >
	>
	type $shm_hitalama_components_drafts_editor__removed_shm_hitalama_components_drafts_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts['close'] >
		,
		ReturnType< $shm_hitalama_components_drafts_editor['removed'] >
	>
	export class $shm_hitalama_components_drafts extends $mol_book2 {
		draft_pages( ): readonly($mol_view)[]
		created( next?: any ): any
		opened( next?: any ): any
		close( next?: any ): any
		model( ): $shm_hitalama_components_drafts_model
		selected( next?: string ): string
		editing( next?: boolean ): boolean
		pages( ): ReturnType< $shm_hitalama_components_drafts['draft_pages'] >
		List( ): $shm_hitalama_components_drafts_list
		Preview( ): $shm_hitalama_components_drafts_preview
		Editor( ): $shm_hitalama_components_drafts_editor
	}
	
}

//# sourceMappingURL=drafts.view.tree.d.ts.map